<script>
	import { onMount } from "svelte";

	export let breakpoint = undefined;
	export let platform = undefined;
	export let orientation = undefined;

	// export const mobileTiny = 359;
	export const mobile = 544;
	export const tablet = 1190;

	const setupBreakpoints = () => {
		const breakpoints = [
			// { value: "mobile-tiny", mediaquery: window.matchMedia(`(max-width:  ${mobileTiny}px)`) },
			{ value: "mobile", mediaquery: window.matchMedia(`(max-width:  ${mobile}px)`) },
			{ value: "mobile", mediaquery: window.matchMedia(`(max-width:  ${mobile}px)`) },
			{
				value: `tablet`,
				mediaquery: window.matchMedia(`(min-width: ${mobile + 1}px) and (max-width: ${tablet}px)`),
			},
			{ value: `desktop`, mediaquery: window.matchMedia(`(min-width: ${tablet + 1}px)`) },
		];

		for (let key in breakpoints) {
			let b = breakpoints[key];

			//set the current breakpoint
			// console.log("set", b.mediaquery.matches, b.value);
			if (b.mediaquery.matches === true) {
				breakpoint = b.value;
			}
			b.mediaquery.addEventListener("change", (event) => {
				// console.log("change", event.matches, b.value);
				if (event.matches === true) {
					breakpoint = b.value;
				}
			});
		}
	};

	const setPlatform = (b) => {
		if (!b) return;
		if (b.includes("mobile")) {
			return "mobile";
		} else if (b.includes("tablet")) {
			return "tablet";
		} else {
			return "desktop";
		}
	};

	$: platform = setPlatform(breakpoint);

	const setupOrientation = () => {
		const orientations = [
			{ value: "portrait", mediaquery: window.matchMedia("(orientation: portrait)") },
			{ value: "landscape", mediaquery: window.matchMedia("(orientation: landscape)") },
		];

		for (let key in orientations) {
			let o = orientations[key];

			//set the current orientation
			if (o.mediaquery.matches === true) {
				orientation = o.value;
			}

			o.mediaquery.addEventListener("change", (event) => {
				if (event.matches === true) {
					orientation = o.value;
				}
			});
		}
	};

	onMount(() => {
		setupBreakpoints();
		setupOrientation();
	});
</script>
